// The reducer that holds column information.
// @flow
import { ACTIONS } from '../actions';
import type { ColumnState } from '../constants';

type Action = {
    columns: ColumnState,
    type: string
};

export const columns = (
    state: ColumnState = [],
    action: Action = { type: '', columns: [] }
): ColumnState => {
    switch (action.type) {
        case ACTIONS.INITIALIZE:
            if (action.columns) {
                return [...action.columns];
            }
            return state;
        default:
            return state;
    }
};
